import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface InitialState {
    user?: User;
    token?: string;
}

const initialState: InitialState = {
    user: undefined,
    token: undefined,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        login: (state, action) => {
            state.user = {
                ...action.payload.user,
                loggedin_at: new Date(),
            };
            state.token = action.payload.access_token;
        },
        refreshUser: (state, action) => {
            state.user = { ...state.user, ...action.payload };
        },
        logout: (state) => {
            state.user = undefined;
            state.token = undefined;
        },
    },
});

// selectors
export const getUser = (state: RootState) => state.auth.user;
export const getAuthToken = (state: RootState) => state.auth.token;

// actions & reducer
export const { actions, reducer } = authSlice;
